import type { Transition, Variants } from 'framer-motion'

/**
 * Shared motion tokens — keeps every animation on the same rhythm
 * (cf. charte CLAUDE.md §15 : 150–250ms). Import these instead of
 * hand-writing durations/easings per component.
 */

// Linear-style "out expo" easing for enter/exit transitions.
export const EASE_OUT: [number, number, number, number] = [0.16, 1, 0.3, 1]

// Snappy spring for hover/press and layout shifts.
export const SPRING: Transition = { type: 'spring', stiffness: 300, damping: 30 }

// Standard fade — content swaps within a container.
export const FADE: Transition = { duration: 0.18, ease: EASE_OUT }

// Slightly longer for full surfaces (modals, page content).
export const SURFACE: Transition = { duration: 0.22, ease: EASE_OUT }

/** Page content enter/exit (used by route transitions). */
export const pageVariants: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -6 },
}

/** Card / list-item entrance. Pair with `transition={FADE}`. */
export const fadeUp: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
}

/** Stagger container for lists/grids (30–50ms per child, cf. UX guidelines). */
export const staggerContainer: Variants = {
  animate: { transition: { staggerChildren: 0.04 } },
}
